import { QuestionTypeEnum } from '@/models/Question';
import { useTranslation } from 'react-i18next';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { useWritingCorrection } from './useWritingCorrection';

export function WritingCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.WRITING>,
) {
  const { answer, hasAnswer } = useWritingCorrection(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  return (
    <div className="flex w-full flex-col gap-2">
      <span className="text-sm text-base-content font-bold">
        {t('studentAnswer')}
      </span>
      <ConditionalRenderer
        condition={hasAnswer}
        fallback={<span className="text-base-content/60">{t('noAnswer')}</span>}
      >
        <p className="w-full whitespace-pre-wrap rounded-lg border border-dashed border-primary p-4 text-base-content bg-primary-content">
          {answer}
        </p>
      </ConditionalRenderer>
    </div>
  );
}
